import BrButton from '@govbr/react-components/lib/BrButton';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { authLogout, selectGovBr } from '../../auth/authSlice';
import Card from '../../components/Card/Card';
import MainContainer from '../../components/MainContainer/MainContainer';
import { selectLogado } from '../IdentificacaoPositiva/identificacaoPositivaSlice';
import { getPerfis, selectPerfilCompleto, selectSituacaoCadastroFamilia } from '../Perfil/perfilSlice';
import styles from './ExclusaoPorObito.module.css';
import AjudaRapida from '../../components/AjudaRapida/AjudaRapida';
import { useEffect, useState } from 'react';
import { selectMembrosFamiliares } from '../ConsultaCompleta/consultaCompletaSlice';
import { tiposRelacaoParentesco } from '../../common/enum';
import { Checkbox, Dialog, DialogContent, DialogContentText } from '@material-ui/core';
import auth from '../../auth/Auth';
import authIdPositiva from '../../auth/AuthIdPositiva';
import Message from '../../components/Message/Message';
import imgErro from '../../assets/img/icone-erro.png';
import imgSucesso from '../../assets/img/icone-sucesso.png';
import membrosFamiliaIcon from '../../assets/img/membros-familia-icon.svg';
import * as Mensagens from '../../common/Mensagens';
import { exclusaoIntegrantesPorObito, exibirMensagemErro, exibirMensagemSucesso, exibirTextoMensagem, hideMensagemErro, hideMensagemSucesso} from './exclusaoPorObitoSlice';
import { trackServiceSelect } from '../../common/tracker';
import { obterNomeDoPerfil } from '../../common/perfilUtils';
import { recarregarBanner } from '../../components/DadosBasicos/dadosBasicosSlice';

const ExclusaoPorObito: React.FC = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const perfil = useAppSelector(selectPerfilCompleto);
  const govBrLogado = useAppSelector(selectGovBr).logado;
  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);
  const isAuthenticatedIdPositiva = useAppSelector(selectLogado);
  const integrantesFamilia: any[] = useAppSelector(selectMembrosFamiliares);
  const integrantesComObito = integrantesFamilia.filter(integrante => integrante.obito && !integrante.solicitacaoExclusaoObito);
  const [exclusaoIniciada, setExclusaoIniciada] = useState(false);

  const [checkboxes, setCheckboxes] = useState(Array(integrantesFamilia.filter(integrante => integrante.obito).length).fill(false));
  const [isCheckedDeclaracao, setIsCheckedDeclaracao] = useState(false);
  const [integrantesSelecionados, setIntegrantesSelecionados] = useState<any[]>([]);
  const [dialogoExplicacao, setDialogoExplicacao] = useState(false);

  const mensagemErro = useAppSelector(exibirMensagemErro);
  const mensagemSucesso = useAppSelector(exibirMensagemSucesso);
  const textoMensagem = useAppSelector(exibirTextoMensagem);

  useEffect(() => {
    if(mensagemSucesso) {
      dispatch(getPerfis(auth.getUser()));
    }
    
  }, [mensagemSucesso])

  useEffect(() => {
    return () => {
      dispatch(hideMensagemErro());
      dispatch(hideMensagemSucesso());

      setIntegrantesSelecionados([]);
    };
  }, [exclusaoIniciada]);

  const handleOnChangeDeclaracao = () => {
    setIsCheckedDeclaracao(!isCheckedDeclaracao);
  };

  const handleCheckboxChange = (index) => {
    const newCheckboxes = [...checkboxes];
    newCheckboxes[index] = !newCheckboxes[index];
    setCheckboxes(newCheckboxes);
    setIsCheckedDeclaracao(false);

    if (newCheckboxes[index]) {
      setIntegrantesSelecionados([...integrantesSelecionados, integrantesComObito[index]]);
    } else {
      setIntegrantesSelecionados(integrantesSelecionados.filter(integrante => integrante !== integrantesComObito[index]));
    }
  };

  const caixaMensagens = () => {
    trackServiceSelect('POR-MENU', "CAIXA DE MENSAGEM");
    history.push('/caixa-mensagem');
  };

  const isLogado = () => {
    return (govBrLogado && situacaoCadastroFamilia) || isAuthenticatedIdPositiva ? true : false;
  };

  const logout = () => {
    dispatch(authLogout({ history }));
  };

  const iniciarExclusaoPorObito = () => {
    setExclusaoIniciada(true);
  };

  const exibirIntegrantes = async() => {
    setDialogoExplicacao(false);
    setExclusaoIniciada(false);

    await dispatch(hideMensagemErro());
    await dispatch(hideMensagemSucesso());

    if (auth.isAuthenticated()) {
      // Logado pelo gov.br, redirecionar para a tela de integrantes da consulta ao formulário
      const historyParams = {
        pathname: '/consultaCompleta',
        state: { mostrarIntegrantes: true }
      };
      if (history.location?.pathname === '/consultaCompleta') {
        history.replace(historyParams);
      } else {
        history.push(historyParams);
      }
    } else if (authIdPositiva.isAuthenticated()) {
      // Na identificação positiva, redirecionar para tela de dados resumidos da família.
      history.push({
        pathname: '/consultaSimples',
        state: { mostrarIntegrantes: true }
      });
    }
  };

  const InicioExclusaoPorObito = (
    <div className={styles.container}>
      <Card>
        <div className={styles.tituloInicio}>Vamos iniciar?</div>
        <div className={styles.userInfo}>
          <i className={`fas fa-id-card-alt ${styles.icon}`} />
          <span>
            <strong>{!!perfil ? perfil?.nome : situacaoCadastroFamilia?.nomeCnis}</strong>,
            aqui você poderá excluir o cadastro de pessoa da família com registro de falecimento.
          </span>
        </div>

        <div style={{marginBottom: 20}}>

        </div>
        <div>
          A funcionalidade EXCLUSÃO DE PESSOA POR MOTIVO DE FALECIMENTO fica disponível de segunda à sábado das 7h às 19h.
        </div><br/>
        <div>
          Se não conseguir concluir hoje, tente novamente amanhã entre 7h e 19h.
        </div>
        <hr />
        <div className={styles.buttonArea}>
          <BrButton
            className={`${styles.button} ${styles.secondary}`}
            onClick={() => handleExplicacao()}
          >
            Voltar
          </BrButton>
          <BrButton className={styles.button} onClick={() => iniciarExclusaoPorObito()}>
            Continuar
          </BrButton>
        </div>
      </Card>
    </div>
  );

  const obterValueRelacaoParentesco = (integrante: any) => {
    const rp = tiposRelacaoParentesco.find(
      (relacaoParentesco) => relacaoParentesco.value === integrante?.tipoRelacaoParentescoRF?.codigo
    );
    return rp ? rp.label : '';
  };

  const listaIntegrantesComObito = () => {

    return integrantesComObito?.map((integrante, index) => {
      return (
        <div key={index} className={styles.blocoItem}>
         <input
            type="checkbox"
            checked={checkboxes[index]}
            onChange={() => handleCheckboxChange(index)}
          />
          <i className={`fas fa-user`}></i>
          <div className={styles.blocoItemLeft}>
            <span className={styles.itemText}>{integrante.pessoaDadosCadastroDTO.nomePessoa}</span>
            <br />
            <span className={styles.itemTextSecondary}>
              {obterValueRelacaoParentesco(integrante)}
            </span>
          </div>
        </div>
      );
    });
  };

  const exibirNomesIntegrantesSelecionados = (finalPonto: boolean) => {
    return integrantesSelecionados?.map((integrante, index) => {
      const isLastElement = index === integrantesSelecionados.length - 1;
      const comOuSemPontoFinal = finalPonto ? '.' : '';
      const comma = isLastElement ? comOuSemPontoFinal : ', ';

      return (
        <span key={index}><b>{integrante.pessoaDadosCadastroDTO.nomePessoa}</b>{comma}</span>
      );
    });
  };

  const handleSpanClick = () => {
    if (checkboxes.some(checkbox => checkbox) && isCheckedDeclaracao) {
      handleOnChangeDeclaracao();
    }
  };

  const confirmarExclusaoPorObito = async () => {
    const listaIdsPessoas = integrantesSelecionados.map(pessoa => pessoa.identificador);

    const dados = {
      numeroFamiliar: perfil.numeroFamiliar,
      nomeSolicitante: perfil.nome,
      listaPessoas: listaIdsPessoas
    };

    trackServiceSelect('POR-CONFIRMAÇÃO', "EXCLUSÃO INTEGRANTE FAMÍLIA POR MOTIVO DE ÓBITO");
    await dispatch(exclusaoIntegrantesPorObito(dados));
    await dispatch(recarregarBanner());
  };

  const someChecked = () => {
    return checkboxes.some(checkbox => checkbox);
  }

  const handleExplicacao = () => {
    setDialogoExplicacao(!dialogoExplicacao);
  };

  const obterMensagemErro = () => {
    if (textoMensagem === Mensagens.MSG_TENTE_NOVAMENTE || textoMensagem === Mensagens.MSG_EXCLUSAO_PESSOA_OBITO_FORA_HORARIO) {
      return <><span>{textoMensagem}</span></>
    }

    if (textoMensagem === Mensagens.MSG_DATA_ALTERACAO_FAMILIA) {
      return <><span>Não foi possível excluir o(s) integrante(s) familiar(es) <b>{exibirNomesIntegrantesSelecionados(false)}</b>.
        Acesse daqui a 1 dia útil e tente novamente ou procure um posto de atendimento do Cadastro Único.</span></>
    }

    if (textoMensagem.includes(Mensagens.MSG_SERVICO_PORTAL_FORA_HORARIO)) {
        return <><span>{textoMensagem}</span></>
    }
    return <>
       <div>
        {integrantesSelecionados.length > 1 && <span>Não foi possível excluir o(s) integrante(s) familiar(es) {exibirNomesIntegrantesSelecionados(true)} Procure um posto de atendimento do Cadastro Único.</span>}
        {integrantesSelecionados.length < 2 && <span>Não foi possível excluir o integrante familiar {exibirNomesIntegrantesSelecionados(true)} Procure um posto de atendimento do Cadastro Único. </span>}
      </div>
    </>
  }

  const exibirMensagens = (
    <>
      {mensagemErro && exclusaoIniciada &&
        <div className={styles.container}>
          <Card className={styles.card}>
            <div className={styles.containerMensagem}>
              <img className={styles.imgMessage} src={imgErro} alt="Imagem de erro"/>
              <Message type={'error'}
                text={obterMensagemErro()}
              />
              <div className={styles.botaoContainer}>
                <BrButton className={styles.botao} onClick={() => exibirIntegrantes()}>
                  OK
                </BrButton>
              </div>
            </div>
          </Card>
        </div>
      }

      {mensagemSucesso && exclusaoIniciada &&
        <div className={styles.container}>
          <Card className={styles.card}>
            <div className={styles.containerMensagem}>
              <img className={styles.imgMessage} src={imgSucesso} alt="Imagem de Sucesso"/>
              <Message type={'success'}
                text={
                  <>
                    <div>
                      {integrantesSelecionados.length > 1 && <span>Os(As) integrante(s) familiares {exibirNomesIntegrantesSelecionados(false)} foram excluídos(as) com sucesso. </span>}
                      {integrantesSelecionados.length < 2 && <span>O(A) integrante familiar {exibirNomesIntegrantesSelecionados(false)} foi excluído(a) com sucesso. </span>}
                    </div>
                  </>
                }
              />
              <div className={styles.botaoContainer}>
                <BrButton className={styles.botao} onClick={() => exibirIntegrantes()}>
                  OK
                </BrButton>
              </div>
            </div>
          </Card>
        </div>
      }
    </>
  )

  const TelaPrincipal = (
    <div className={styles.container}>
      <Card>
        <div className={styles.cardHeader}>
          <img className={styles.cardIcon} src={membrosFamiliaIcon} alt="Icone membros" />
          <span className={styles.cardHeaderTitle}>Integrantes com registro de falecimento</span>
        </div>
        <div>
          {listaIntegrantesComObito()}
        </div>
        <hr/>
        <div className={styles.checkboxWrapper}>
          <Checkbox
            color="primary"
            disabled={!someChecked()}
            onChange={handleOnChangeDeclaracao}
            checked={isCheckedDeclaracao}
            className={`${!someChecked() ? styles.checkboxDisabled : styles.checkboxEnabled} `}
            inputProps={{ 'aria-label': 'secondary checkbox' }}
          />
          <span
            className={styles.checkboxText}
            onClick={!someChecked() ? handleSpanClick : undefined}
            style={{ cursor: !someChecked() ? 'pointer' : 'not-allowed' }}
          >
            Confirmo que desejo excluir do Cadastro Único a(s) pessoa(s) selecionada(s) acima com registro de falecimento.
          </span>
        </div>
        <div className={styles.buttonArea}>
          <BrButton
            onClick={() => confirmarExclusaoPorObito()}
            className={styles.button}
            disabled={!isCheckedDeclaracao}
          >
            Confirmar
          </BrButton>
          <BrButton
            onClick={() => handleExplicacao()}
            className={`${styles.button} ${styles.secondary}`}
          >
            Cancelar
          </BrButton>
        </div>
      </Card>
    </div>
  );

  return (
    <MainContainer
      userNav={isLogado()}
      navTitle={obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}
      titleBarraAuxiliar="Exclusão de pessoa por motivo de falecimento"
      barraAuxiliar={isLogado()}
      stoppedTitle={true}
      navFixed
      navCaixaMensagens={isLogado() ? caixaMensagens : undefined}
      navHideArrow
      navLogout={isLogado() ? logout : undefined}
    >
      {exibirMensagens}
      {!mensagemErro && !mensagemSucesso && (
        <>
          {exclusaoIniciada && TelaPrincipal}
          {!exclusaoIniciada && InicioExclusaoPorObito}
          <div className={styles.container}>

            <AjudaRapida>
              <b>Passo 1</b> - Revise os dados da pessoa com registro de falecimento (Nome e grau de parentesco);
              <br />
              <b>Passo 2</b> - Após conferir as informações, selecione a pessoa que será excluída;
              <br />
              <b>Passo 3</b> - Confirme que você deseja excluir a pessoa com registro de falecimento;
              <br />
              <b>Passo 4</b> - Selecione o botão Confirmar para efetuar a exclusão.
              <br />
              <br />
              <b>Atenção</b>: Caso sua família tenha mais de uma pessoa com registro de falecimento, é importante que todas sejam excluídas.
              <p />
            </AjudaRapida>
          </div>
        </>
      )}

      <Dialog
        open={dialogoExplicacao}
        onClick={() => exibirIntegrantes()}
        onClose={() => exibirIntegrantes()}
      >
        <DialogContent>
          <DialogContentText>
            <span className={styles.textoDialogo}>
              <b>Você desistiu, porém o indicativo de falecimento poderá provocar bloqueios de benefícios, caso sua família receba algum programa social do Governo Federal.
              <p/>Em caso de dúvidas, o RF da família poderá comparecer ao CRAS ou posto de atendimento do Cadastro Único, no seu município, para realizar a atualização cadastral.</b>
            </span>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Dialog
        open={dialogoExplicacao}
      >
        <DialogContent>
          <div className={styles.modalTitle}>
            Olá, {obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}
          </div>
          <div className={styles.modalContent}>
            <span className={styles.textoDialogo}>
                <b>Você desistiu, porém o indicativo de falecimento poderá provocar bloqueios de benefícios, caso sua família receba algum programa social do Governo Federal.
                <p/>Em caso de dúvidas, o RF da família poderá comparecer ao CRAS ou posto de atendimento do Cadastro Único, no seu município, para realizar a atualização cadastral.</b>
            </span>
          </div>
          <div className={styles.modalFooter}>
            <BrButton
              className={`${styles.button} ${styles.secondary}`}
              onClick={() => exibirIntegrantes()}
            >
              Cancelar
            </BrButton>
            <BrButton
              className={styles.button}
              onClick={() => {
                setDialogoExplicacao(false);
              }}
            >
              Continuar
            </BrButton>
          </div>
        </DialogContent>
      </Dialog>
    </MainContainer>
  );
};

export default ExclusaoPorObito;
